<template>
  <div class="edit-video-box">
    <el-dialog :title="title" :visible.sync="dialogVisible" width="600px" :before-close="handleClose" :close-on-click-modal="false">
      <el-form ref="form" :model="params" :rules="rules" label-width="120px">
        <el-form-item label="上传城市图片:" prop="cover">
          <base-upload :cover="params.cover" :action="action" @successCallback="successCallback" :wSize="360" :hSize="480" :width="'180px'" :height="'240px'"></base-upload>
        </el-form-item>
        <el-form-item label="访问量(假):" prop="fakeVisit">
          <el-input v-model.number="params.fakeVisit" placeholder="请输入播放量"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" :loading="flag" size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { validatorIndex } from '@/utils/validator'
import API from '@/api'
import baseConfig from '@/utils/serverUrlConfig'

export default {
  data() {
    return {
      dialogVisible: false,
      title: '城市背景图',
      flag: false,
      id: '',
      // 封面上传地址
      action: baseConfig.baseServerUrl + '/vid/uploadStatic',
      params: {
        cover: '',
        fakeVisit: 0,
      },
      // 表单验证规则
      rules: {
        fakeVisit: [
          { required: true, message: '请输入播放量（假）', trigger: 'blur' },
          { validator: validatorIndex, trigger: 'blur' }
        ],
        cover: [{ required: true, message: '请上传背景图', trigger: 'blur' }]
      }
    }
  },
  methods: {
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true
          if (this.type === 'add') {
            this.addCity()
          } else {
            this.editCity()
          }
        } else {
          return false;
        }
      });
    },
    addCity() {
      return
    },
    // 编辑标签
    editCity() {
      let params = Object.assign(this.params, { targetID: this.id });
      API.updateCity(params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '编辑成功',
            type: 'success'
          });
          this.$emit('handlerCityList')
        } else {
          this.$message.error('编辑失败');
        }
        this.handleClose();
        this.flag = false
      }).catch(() => {
        this.handleClose();
        this.flag = false
      })
    },
    // 标签封面上传成功回掉
    successCallback(res) {
      this.params.cover = res.data.coverImg
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.params = {
        cover: '',
        fakeVisit: 0
      }
      this.$refs.form.resetFields()
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(type, data) {
      this.dialogVisible = true
      if (type === 'edit') {
        this.title = '编辑城市'
        this.params.fakeVisit = data.fakeVisit
        this.params.cover = data.cover
        this.id = data.id
      } else {
        this.title = '新增城市'
      }
    }
  }

}
</script>

<style lang="scss" >
.edit-video-box {
  .el-input {
    width: 150px;
  }
  .avatar-uploader {
    width: 150px;
    height: 150px;
  }
  .el-upload {
    width: 100%;
    height: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover {
      border: 1px dashed #e63765;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
    &:hover {
      color: 1px dashed #e63765 !important;
    }
  }
}
</style>
